/**
 * 模組頁面代碼 : 1220-UI-05
 * 頁面說明 : 梯控設定新增修改視窗
 * @module web/modules/building/components/ControlDeviceModal
 */

// ----- import from npm modules -----
import React, { useState, useEffect } from 'react';

import { MessageModalModeEnums } from 'web/components/MessageModal';

// ----- constants -----
const RESPONSE_OK = 200;
const TITLE_DEFAULT_PERIOD = '設定預設有效天數';

const DefaultPeriodModal = React.forwardRef((props, ref) => {
    const { buildingSelection, onLoad, setLoad } = props;
    // 初始化state
    const [buildingId, setBuildingId] = useState();
    const [dufaultPeriodDays, setDefaultPeriodDays] = useState();
    const [invalidShow, setInvalidShow] = useState('none');

    // Handle change event
    const convertToHalfWidth = (value) => {
        const v = value.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        return v;
    }

    // 使用useEffect在expirationDays改變才更新formValues
    useEffect(() => {
        if (onLoad) {
            setBuildingId(0);
            setDefaultPeriodDays(1);
            setLoad(false);
        }
        setInvalidShow('none');
    }, [onLoad]);

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            setInvalidShow('block');
            return;
        }
        form.classList.add('was-validated');

        // 建立 FormData 讀取表单的值
        const formData = new FormData(form);

        // 讀取表單的預設天數值
        const buildingId = parseInt(formData.get('modalBuilding'));
        const defaultPeriod = parseInt(formData.get('modalDefaultPeriodDays'));

        if ((buildingId > 0 ) && (defaultPeriod >= 1)) {
            // 呼叫父層元件的修改大樓預設有效天數函式
            props.updateDefaultPeriod(buildingId, defaultPeriod).then((response) => {
                const statusCode = response.payload.code;
                if (statusCode !== RESPONSE_OK) {
                    props.onShowMessageModal(MessageModalModeEnums.ERROR, TITLE_DEFAULT_PERIOD, response.payload );
                } else {
                    props.onShowMessageModal(MessageModalModeEnums.INFO, TITLE_DEFAULT_PERIOD, '設定預設有效天數成功');
                    props.fetchBuildingSelection();
                }
            });
            $(ref.current).modal('hide');
        } else {
            setInvalidShow('block');
        }
    }
    return (
        <div ref={ref}
            className="modal fade"
            id="modalDefaultPeriod"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="modalDefaultPeriodLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-sm modal-dialog-centered">
                <form className="modal__form modal-content" id="modalDefaultPeriodForm" onSubmit={handleSubmit}>
                    <div className="modal-header border-bottom-0">
                        <h1 className="modal-title fs-5" id="modalDefaultPeriodLabel">
                            <div className="modal__title__badge" id="modalDefaultPeriodBadge">
                                <svg className="badge__icon" aria-hidden="true">
                                    <use href="#ico-hourglass"></use>
                                </svg>
                            </div>
                            <div className="modal__title__text">設定預設有效天數</div>
                        </h1>
                        <button type="button" className="btn-close btn-cancel" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="d-flex flex-column gap-3 px-2">
                            <div className="row">
                                <div className="col">
                                    <label htmlFor="modalBuilding" className="form-label">大樓名稱*</label>
                                    <select
                                        className="form-select form-select-sm"
                                        id="modalBuilding"
                                        name="modalBuilding"
                                        value={buildingId || 0}
                                        onChange={(e) => {
                                            const newBuildingId = parseInt(e.target.value, 0); // Convert to number
                                            setBuildingId(newBuildingId);
                                            const selectedBuilding = buildingSelection.find((building) => building.buildingId === newBuildingId);
                                            if (selectedBuilding) {
                                                const expirationDay = parseInt(selectedBuilding.expirationDay, 0);
                                                setDefaultPeriodDays(expirationDay);
                                            }
                                        }}
                                        required>
                                            <option disabled value="0">請選擇</option>
                                            {buildingSelection.map((building, index) => (
                                                <option key={index} value={building.buildingId}>{building.buildingName}</option>
                                            ))}
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <input
                                        type="number"
                                        min="1"
                                        max="365"
                                        className="form-control text-center"
                                        id="modalDefaultPeriodDays"
                                        name="modalDefaultPeriodDays"
                                        value={dufaultPeriodDays || 1}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const halfWidthValue = convertToHalfWidth(value);
                                            setDefaultPeriodDays(halfWidthValue);
                                        }}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="alert alert-warning global-invalid-feedback" style={{ display: invalidShow }}></div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-cancel" data-bs-dismiss="modal">取消</button>
                        <button type="submit" className="btn btn-primary">儲存</button>
                    </div>
                </form>
            </div>
        </div>
    );
});

export default DefaultPeriodModal;